import { addError } from '../../store/Error';
import { isTokenExpired } from '../callExternalApi';

export const validateTokenApi = async (token: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_SERVER_URL}/api/user/validate_token`, {
    method: 'GET',
    headers: new Headers({
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }),
    keepalive: true
  });
  const data = await response.json();
  if (response.status === 401 && isTokenExpired(token)) {
    addError('session', 'Request failed with status code 401');
  }
  return response.ok ? { data, error: null } : { data: null, error: data };
};
